/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { portfolioCategoryAdminControllerCreateV1 } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-create-v-1';
import { PortfolioCategoryAdminControllerCreateV1$Params } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-create-v-1';
import { portfolioCategoryAdminControllerDeleteV1 } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-delete-v-1';
import { PortfolioCategoryAdminControllerDeleteV1$Params } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-delete-v-1';
import { portfolioCategoryAdminControllerFindAllV1 } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-find-all-v-1';
import { PortfolioCategoryAdminControllerFindAllV1$Params } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-find-all-v-1';
import { portfolioCategoryAdminControllerUpdateV1 } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-update-v-1';
import { PortfolioCategoryAdminControllerUpdateV1$Params } from '../fn/portfolio-category-admin/portfolio-category-admin-controller-update-v-1';
import { PortfolioCategoryDto } from '../models/portfolio-category-dto';

@Injectable({ providedIn: 'root' })
export class PortfolioCategoryAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `portfolioCategoryAdminControllerFindAllV1()` */
  static readonly PortfolioCategoryAdminControllerFindAllV1Path = '/api/v1/portfolios/categories/admin';

  /**
   * Get all portfolio categories.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioCategoryAdminControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioCategoryAdminControllerFindAllV1$Response(params?: PortfolioCategoryAdminControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PortfolioCategoryDto>>> {
    const obs = portfolioCategoryAdminControllerFindAllV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get all portfolio categories.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioCategoryAdminControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioCategoryAdminControllerFindAllV1(params?: PortfolioCategoryAdminControllerFindAllV1$Params, context?: HttpContext): Observable<Array<PortfolioCategoryDto>> {
    const resp = this.portfolioCategoryAdminControllerFindAllV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<PortfolioCategoryDto>>): Array<PortfolioCategoryDto> => r.body)
    );
  }

  /** Path part for operation `portfolioCategoryAdminControllerCreateV1()` */
  static readonly PortfolioCategoryAdminControllerCreateV1Path = '/api/v1/portfolios/categories/admin';

  /**
   * Create portfolio category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioCategoryAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioCategoryAdminControllerCreateV1$Response(params: PortfolioCategoryAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioCategoryDto>> {
    const obs = portfolioCategoryAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create portfolio category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioCategoryAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioCategoryAdminControllerCreateV1(params: PortfolioCategoryAdminControllerCreateV1$Params, context?: HttpContext): Observable<PortfolioCategoryDto> {
    const resp = this.portfolioCategoryAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioCategoryDto>): PortfolioCategoryDto => r.body)
    );
  }

  /** Path part for operation `portfolioCategoryAdminControllerDeleteV1()` */
  static readonly PortfolioCategoryAdminControllerDeleteV1Path = '/api/v1/portfolios/categories/admin/{id}';

  /**
   * Delete portfolio category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioCategoryAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioCategoryAdminControllerDeleteV1$Response(params: PortfolioCategoryAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioCategoryDto>> {
    const obs = portfolioCategoryAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete portfolio category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioCategoryAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  portfolioCategoryAdminControllerDeleteV1(params: PortfolioCategoryAdminControllerDeleteV1$Params, context?: HttpContext): Observable<PortfolioCategoryDto> {
    const resp = this.portfolioCategoryAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioCategoryDto>): PortfolioCategoryDto => r.body)
    );
  }

  /** Path part for operation `portfolioCategoryAdminControllerUpdateV1()` */
  static readonly PortfolioCategoryAdminControllerUpdateV1Path = '/api/v1/portfolios/categories/admin/{id}';

  /**
   * Update portfolio category.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `portfolioCategoryAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioCategoryAdminControllerUpdateV1$Response(params: PortfolioCategoryAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PortfolioCategoryDto>> {
    const obs = portfolioCategoryAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update portfolio category.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `portfolioCategoryAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  portfolioCategoryAdminControllerUpdateV1(params: PortfolioCategoryAdminControllerUpdateV1$Params, context?: HttpContext): Observable<PortfolioCategoryDto> {
    const resp = this.portfolioCategoryAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PortfolioCategoryDto>): PortfolioCategoryDto => r.body)
    );
  }

}
